import React from "react";
import {
	Controller,
	ControllerRenderProps,
	useFormContext,
} from "react-hook-form";

import { DatePickerRange, DatePickerWithLoaderWrapper } from "components";
import { FilterColumnDateProps } from "types";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumnDateProps;
};

const FilterDatePickerRange = ({ column }: FilterColumnProps) => {
	const { control, setValue } = useFormContext();

	return (
		<Controller
			control={control}
			name={column.name || ""}
			defaultValue={null}
			render={({ field }: { field: ControllerRenderProps }) => (
				<DatePickerWithLoaderWrapper
					input={field}
					isLoading={false}
					renderDatePicker={input => (
						<DatePickerRange
							value={input?.value}
							onChange={value => {
								setValue(input?.name || "", value);
							}}
							placeholderText={column.placeholder}
							wrapperClassName={styles.column}
							minDate={column.minDate}
							maxDate={column.maxDate}
						/>
					)}
				/>
			)}
		/>
	);
};

export default FilterDatePickerRange;
